import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { normalizeStoredToken } from './authSession';

const ProtectedRoute = ({ children }) => {
  const location = useLocation();
  const profileFetchStatus = useSelector((s) => s.user.profileFetchStatus);
  const token = normalizeStoredToken(localStorage.getItem('token'));

  if (!token) {
    return <Navigate to={`/login?callbackUrl=${location.pathname}`} replace />;
  }

  if (
    profileFetchStatus === 'failed' &&
    !normalizeStoredToken(localStorage.getItem('token'))
  ) {
    return <Navigate to={`/login?callbackUrl=${location.pathname}`} replace />;
  }

  return children;
};

export default ProtectedRoute;